import McFunnelChart from './McFunnelChart';

export default McFunnelChart;
